import { doc, getDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const GetSingleExpense = async (ExpenseId) => {
  try {
    const ExpenseRef = doc(db, "Expenses", ExpenseId);

    const ExpenseSnapshot = await getDoc(ExpenseRef);
    let SingleExpense;
    if (ExpenseSnapshot.exists()) {
      SingleExpense = {
        id: ExpenseSnapshot.id,
        ...ExpenseSnapshot.data(),
      };
    }

    return SingleExpense;
  } catch (error) {
    console.log("Error Getting Expense Data:", error);
    return;
  }
};

export default GetSingleExpense;
